import styled from 'styled-components';

export const FooterContainer = styled.footer`
  display: flex;
  background: #333333;
  flex-direction: column;
  justify-content: space-around;
  width: 100%;
  bottom: 0px;

  @media print {
    display: none;
  }

  a {
    text-decoration: none;
    font-family: ${(props) => props.theme.font.body.family};
    font-size: ${(props) => props.theme.font.body.size.small};
    font-weight: ${(props) => props.theme.font.body.weight.regular};
    line-height: ${(props) => props.theme.font.body.lineHeight.small};
    color: #999999;

    &:hover {
      text-decoration: underline;
    }
  }
`;

export const InfoBox = styled.div`
  display: flex;
  padding: 15px 10px 0 10px;
  align-items: center;
  margin-right: 64px;
  align-self: flex-end;
  justify-content: space-between;
  gap: 1.5em;

  img {
    width: 105px;
    height: auto;
  }

  ul {
    list-style: none;
    li {
      font-size: 12px;
      color: #999999;
      cursor: pointer;

      span {
        color: inherit;
        &:hover {
          text-decoration: underline;
        }
      }
    }
  }

  @media only screen and (max-width: 768px) {
    margin: 0;
    align-self: auto;
  }
`;

export const CopyrightBox = styled.div`
  border-top: 1px solid #999999;
  padding: 10px 64px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  span {
    color: #999999;
  }

  @media only screen and (max-width: 768px) {
    span {
      &:nth-child(1) {
        width: 50%;
      }
    }
    padding: 20px 10px;
  }
`;
